import { Card, Icon, TextBody } from '@pypestream/design-system';
import { useTranslation } from '@pypestream/translations';

import './maestro-org.scss';

const key = (name: string) => `manager/organizations:orgTabs.${name}`;

export function NoAccessCard() {
  const { t } = useTranslation();
  return (
    <Card size="large" shadow="none" border="default" test-id="org-no-access">
      <div className="c-org-no-access">
        <span className="c-org-no-access__mark" aria-hidden="true">
          <Icon name="lock" />
        </span>
        <h2 className="c-org-no-access__title">{t(key('noAccess.title'))}</h2>
        <TextBody variant="secondary">{t(key('noAccess.body'))}</TextBody>
      </div>
    </Card>
  );
}

export function ViewOnlyNote() {
  const { t } = useTranslation();
  return (
    <p className="c-org-view-only" data-test-id="org-view-only">
      <Icon name="info" size="small" aria-hidden="true" />
      {t(key('viewOnly'))}
    </p>
  );
}
